import React from "react";
import { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const CourseDetails = () => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const courseName = params.get("name");
  //   const { courseName } = useParams(); // Capture the course name from the URL
  //   const [data, setData] = useState(null);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1); // Navigate to the previous page in history
  };
  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const response = await fetch("/data.json");
        if (!response.ok)
          throw new Error(`HTTP error! Status: ${response.status}`);
        const data = await response.json();

        // setData(data.courses);

        // Find the course matching the course from the URL
        const foundCourse = data.courses.find(
          (course) =>
            course.coursename.toLowerCase().replace(/\s+/g, "-") === courseName
        );

        setSelectedCourse(foundCourse || data.courses[0]); // Fallback to the first course
      } catch (error) {
        console.error("Error loading data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCourses();
  }, [courseName]);

  if (loading) {
    return <div>Loading...</div>;
  }

  const { whatWillILearn, description, modules, contact, course } =
    selectedCourse;

  return (
    <div className="container course_details">
      <div className="row">
        <div className="col-lg-12 mt-5">
          <div className="border-0 mb-5 course-details">
            <h1 className="mb-5">{course}</h1>
            <div className="wideget-user-tab wideget-user-tab3">
              <div className="tab-menu-heading">
                <div className="tabs-menu1">
                  <ul className="nav nav-pills">
                    <li className="ms-md-0">
                      <a href="#tab-1" className="active" data-bs-toggle="tab">
                        Overview
                      </a>
                    </li>
                    <li>
                      <a href="#tab-2" data-bs-toggle="tab" className="">
                        Curriculum
                      </a>
                    </li>
                    <li>
                      <a href="#tab-3" data-bs-toggle="tab" className="">
                        Instructor
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="tab-content border-0 p-5 bg-white details-tab-content">
              {/* Tab 1: What Will I Learn */}
              <div className="tab-pane active" id="tab-1">
                <h3 className="card-title mb-3 font-weight-bold">
                  What Will I Learn?
                </h3>
                <ul className="list-group mb-5 description">
                  {whatWillILearn.map((item, index) => (
                    <li key={index} className="mb-0">
                      <p>
                        <i className="fa fa-caret-right me-1 text-primary" />
                        {item}
                      </p>
                    </li>
                  ))}
                </ul>
                <h3 className="card-title mb-3 font-weight-bold">
                  Description
                </h3>
                <div className="mb-0 description">
                  <p>{description.main}</p>
                  <p>{description.additional}</p>
                </div>
              </div>
              {/* Tab 2: Modules */}
              <div className="tab-pane" id="tab-2">
                {modules.map((module, index) => (
                  <div key={index} className="mb-4">
                    <h5>{module.title}</h5>
                    <p>{module.description}</p>
                  </div>
                ))}
              </div>
              {/* Tab 3: Contact */}
              <div className="tab-pane" id="tab-3">
                <div className="profile-pic mb-0 text-start">
                  <h4 className="mb-1 font-weight-semibold">{contact.name}</h4>
                  <span className="text-muted">
                    Member Since {contact.memberSince}
                  </span>
                  <h6>
                    <i className="fe fe-map-pin" /> {contact.address}
                  </h6>
                  <h6>
                    <i className="fe fe-mail" /> {contact.email}
                  </h6>
                  <h6>
                    <i className="fe fe-phone" /> {contact.phone}
                  </h6>
                  <h6>
                    <i className="fe fe-link" />{" "}
                    <a href={contact.website}>{contact.website}</a>
                  </h6>
                </div>
              </div>
            </div>
            <div className="card-footer bg-white br-bs-7 br-be-7">
              <div className="btn-list">
                <Link to="/register" className="btn btn-success">
                  Register
                </Link>
                <button onClick={handleBack} className="btn btn-success ml-2">
                  Go Back
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CourseDetails;
